import axios from "axios";
import { decryptData } from "utils/encryption";
import { getCookie } from "./cookies";

axios.defaults.baseURL = `${process.env.REACT_APP_ENDPOINT}`;

export const http_get = async (url, auth = true, data = {}) => {
  if (auth) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " +
      decryptData(
        (await getCookie("token_siswa")) || localStorage.getItem("token_siswa")
      );
  }
  return axios.get(url, data);
};

export const http_post = async (url, auth = true, data = {}) => {
  if (auth) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " +
      decryptData(
        (await getCookie("token_siswa")) || localStorage.getItem("token_siswa")
      );
  }
  return axios.post(url, data);
};

export const http_put = async (url, auth = true, data = {}) => {
  if (auth) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " +
      decryptData(
        (await getCookie("token_siswa")) || localStorage.getItem("token_siswa")
      );
  }
  return axios.put(url, data);
};

export const http_delete = async (url, auth = true, data = {}) => {
  if (auth) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " +
      decryptData(
        (await getCookie("token_siswa")) || localStorage.getItem("token_siswa")
      );
  }
  return axios.delete(url, { data: data });
};
